import billboard, { ChartOptions } from 'billboard.js';
import React, { useRef } from 'react';
import BillboardJS, { IChart } from '@billboard.js/react';

export const Chart: React.FC<{ options: ChartOptions }> = (props) => {
    const chartComponent = useRef<IChart>(null);
    return <BillboardJS bb={billboard} options={props.options} ref={chartComponent} />;
};
